//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class MembershipTransactionSearchOptions extends ItemBase {
    IDs: string[] = [];
    StartDate: string | null = null;
    EndDate: string | null = null;
    TransactionID: string | null = null;

    constructor(initializer?: Partial<MembershipTransactionSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MembershipTransactionSearchOptions";
}
